module.exports = __webpack_public_path__ + "static/media/rotaLink404.e71d169d.svg";